"use client";

import Script from "next/script";
import { useState, useEffect } from "react";
import getLandingPageStoryOrFail from "@/storyblok/landingpages";

export default function GoogleTagManager() {
  const [gtmId, setGtmId] = useState<string | null>(null);

  useEffect(() => {
    const fetchStory = async () => {
      const pathname = window.location.pathname;
      const hostname = window.location.hostname;
      const subdomain = hostname.split(".")[0];

      let story = null;

      try {
        if (pathname.length >= 2) {
          story = await getLandingPageStoryOrFail(pathname);
        } else if (subdomain.length >= 2 && !hostname.includes(".csbeta.nl")) {
          story = await getLandingPageStoryOrFail(subdomain);
        }
      } catch (error) {
        console.error("Failed to fetch the story:", error);
      }

      if (story?.content?.gtm?.containerid) {
        setGtmId(story.content.gtm.containerid);
      } else {
        setGtmId(process.env.NEXT_PUBLIC_GTM_ID || null);
      }
    };

    fetchStory();
  }, []);

  return !!gtmId ? (
    <Script id="google-tag-manager" strategy="afterInteractive">
      {`
            (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
            new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
            j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
            'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
            })(window,document,'script','dataLayer','${gtmId}');
        `}
    </Script>
  ) : null;
}
